import {
  addressExcelForm,
  DATA_START_ROW,
  ExcelValidationError,
  FormValue,
} from './AddressBookExcelForm';
import validateColumnValue from './validateColumnValue';

export default function validateFormValues(formValues: FormValue[]): ExcelValidationError[] {
  const defaultSigningMethodFormIndex = addressExcelForm.findIndex(
    (c) => c === 'DEFAULT_FORWARDING_METHOD'
  );
  const emailFormIndex = addressExcelForm.findIndex((c) => c === 'EMAIL');
  const phoneFormIndex = addressExcelForm.findIndex((c) => c === 'PHONE_NUMBER');

  return formValues.flatMap((rowData, rowIndex): ExcelValidationError[] => {
    const rowNumber = rowIndex + DATA_START_ROW;
    const rowErrors = rowData.map((columnData, columnIndex): ExcelValidationError | null => {
      const type = addressExcelForm[columnIndex];

      return validateColumnValue({
        columnIndex,
        rowIndex: rowNumber,
        type,
        value: columnData,
      });
    });

    const defaultSigningMethod = rowData[defaultSigningMethodFormIndex];
    const emailValue = rowData[emailFormIndex];
    const phoneValue = rowData[phoneFormIndex];
    /**
     * 각 셀 데이터에서 검사할 수 없는 유효성 검사는 row 읽는 loop 주기에 검사합니다.
     * 1. 기본 전송수단으로 지정한 연락처가 없는 경우
     */
    if (defaultSigningMethod === 'EMAIL' && !emailValue) {
      rowErrors.push({
        column: emailFormIndex,
        message: '기본 전송 수단입력은 필수입니다.',
        row: rowNumber,
        type: 'EMAIL',
      });
    }

    if (defaultSigningMethod === 'KAKAO' && !phoneValue) {
      rowErrors.push({
        column: phoneFormIndex,
        message: '기본 전송 수단입력은 필수입니다.',
        row: rowNumber,
        type: 'PHONE_NUMBER',
      });
    }

    return rowErrors.filter((item): item is ExcelValidationError => item !== null);
  });
}
